export var POSITION_STATUSES = {
  NotClose: 1,
  Close: 2
};
export var CLOSE_TYPES = {
  NormalClose: 0,
  CloseByMarket: 1,
  CloseBySettlement: 2
};